<template>
  <div>
    <div id="printTest" style="border:solid 2px #000000;width:794px;">
      <div style="text-align: center"><h1>{{ decodeURI(name) }}</h1></div>

      <div v-for="(item,index) in viewtemp">
        <parserview v-if="item.show!==false" :temp="item" :showlabel="true" :print="true" :key="index" :datas="viewdatas"></parserview>
      </div>

    </div>
    <div>
    </div>
  </div>
</template>

<script>
import u from "../../../assets/js/util";
import parserview from "./parser_view";
// import Print from 'vue-print-nb'
//
// Vue.use(Print);

export default {
  components: {parserview},
  data() {
    return {
      viewdatas: {},
      viewtemp: [],
      name: ""
    }
  },
  name: "lookfrom",
  async mounted() {


    this.name = getUrlParam("n")
    var res = await u.get_field_module(getUrlParam("s"))
    this.viewdatas = await u.post("comprehensive", "getviewdata", {m: getUrlParam("modul"), i: getUrlParam("i")})

    for (var i = 0; i < res.length; i ++) {
      res[i].is_show = true

    }

    if (res === false) {
      return
    }
    this.field = res


    this.field.push({
      "name": "新增日期",
      "key": "add_time",
      "value": "",
      "label": "新增日期",
      "type": "datetime",
      "level": "admin",
      "is_delete": 1,
      is_show: true
    })


    this.field.push({
      "name": "新增人",
      "key": "add_username",
      "value": "",
      "label": "新增人",
      "type": "input",
      "level": "admin",
      "is_delete": 1,
      is_show: true
    })

    this.field.push({
      "name": "修改日期",
      "key": "update_time",
      "value": "",
      "label": "修改日期",
      "type": "datetime",
      "level": "admin",
      "is_delete": 1,
      is_show: true
    })
    this.field.push({
      "name": "修改人",
      "key": "add_username",
      "value": "",
      "label": "修改人",
      "type": "input",
      "level": "admin",
      "is_delete": 1,
      is_show: true
    })

    this.viewtemp = this.field
    this.$forceUpdate()

  }

}

function getUrlParam(name) {
  return getQueryVariable(name);
}

function getQueryVariable(variable) {
  var query = window.location.href.substring(1);
  query = query.split("?")[1]
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i ++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/lookfrom.vue